import curd from '../curd'

const BASE_PATH = '/integral/upload'

export default curd(BASE_PATH, {
  upload: uploadOpts => {
    let param = new FormData()

    let data = uploadOpts.data

    if (typeof data === 'object') {
      for (let key in data) {
        param.append(key, data[key])
      }
    }

    param.append('file', uploadOpts.file)

    return {
      url: uploadOpts.action,
      method: 'POST',
      data: param,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  },
  saveData: query => ({
    url: `/multiple/${BASE_PATH}/save`,
    method: 'POST',
    data: query
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Integral.js